import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'

@Component({
  selector: 'se-po-registration-list-docs',
  templateUrl: './registration-list-docs.component.html',
  styleUrls: ['./registration-list-docs.component.scss'],
  standalone: false,
})
export class RegistrationListDocsComponent implements OnInit {

  public form: FormGroup
  public personaId: string | number

  public ngOnInit(): void {
    this.form = new FormGroup({
      personaId: new FormControl()
    })
  }

  public updatePersonaId(): void {
    const personaId = Number(this.form.value.personaId)
    if (!Number.isInteger(personaId)) {
      return
    }
    this.personaId = personaId
  }

}
